import css from 'styled-jsx/css';
import { svgUrl } from '../../utils/staticUrls';
import { colors, typography } from '../../config/styles';

const ProPriceStyles = css`
  .pro-prices-container {
    margin-top: 20px;
  }

  .pro-prices-icon-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 2px;
  }

  .pro-prices-icon-pe {
    background-image: url(${svgUrl('proPrice_sope.svg')});
    width: 107px;
    height: 17px;
    display: inline-block;
    background-repeat: no-repeat;
  }

  .pro-prices-icon-cl {
    background-color: ${colors.red.shade5};
    color: ${colors.white.shade1};
    width: 60px;
    font-size: 9px;
    line-height: 10px;
    padding: 2px;
    font-family: 'Helvetica Neue', Lato, sans-serif;
    font-weight: 900;
    height: 25px;
    margin-bottom: 3px;
  }

  .pro-prices-badge {
    height: 16px;
    width: auto;
    background-color: ${colors.black.shade14};
    border: 0.5px solid #fd0;
    border-radius: 0 4px 0 0;
    padding: 0 3px;
    font-size: ${typography.sm2};
    font-weight: 700;
    color: ${colors.white.shade1};
    letter-spacing: -0.22px;
    display: flex;
    align-items: center;
    &.cl {
      background-color: ${colors.red.shade5};
      border: none;
      border-radius: 0;
      height: 25px;
      font-family: 'Helvetica Neue', Lato, sans-serif;
    }
  }

  .unit-pro-price {
    font-size: ${typography.xl3};
    font-weight: 700;
    line-height: 32px;
  }
  .unit-pro-price.CART {
    font-size: ${typography.xl2};
  }

  .pro-price {
    font-size: ${typography.lg2};
    font-weight: 400;
    line-height: 20px;
  }

  .divider {
    font-size: ${typography.lg2};
    font-weight: 400;
    line-height: 20px;
  }

  .pro-price-no-unit {
    font-size: ${typography.xl3};
    font-weight: 700;
    line-height: 32px;
  }
  .pro-price-no-unit.CART {
    font-size: ${typography.xl};
  }
`;

export { ProPriceStyles as ProPricesStyles };
